import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import api from "_api";
import { concat } from "lodash";

const defaultArrowStyle = {
  color: "white", // สีของไอคอนลูกศร
  backgroundColor: "rgba(0, 0, 0, 0.5)", // สีพื้นหลังของไอคอน
  height: "32px", // ความสูงของไอคอน
  width: "32px", // ความกว้างของไอคอน
  position: "absolute",
  zIndex: 10,
  padding: "6px",
  cursor: "pointer",
  "&:hover": {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  borderRadius: "50%",
};

const settingsMain = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: (
    <ArrowForwardIos
      sx={{
        ...defaultArrowStyle,
        right: "5%",
        top: "50%",
      }}
    />
  ),
  prevArrow: (
    <ArrowBackIosNew
      sx={{
        ...defaultArrowStyle,
        left: "5%",
        top: "50%",
      }}
    />
  ),
};

const columns = [
  { key: "updated_at", title: "อัปเดต" },
  { key: "product_code", title: "รหัสสินค้า" },
  { key: "category", title: "หมวดหมู่สินค้า" },
  { key: "defects", title: "ตำหนิ" },
  { key: "stock", title: "จำนวนคงเหลือ" },
  { key: "contact", title: "ช่องทางการติดต่อ" },
];

const ModalProduct = ({ open = false, product = null, closeModal }) => {
  let silderRef = useRef(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (open && product) {
      fetchProductData();
    }
  }, [product, open]);

  const fetchProductData = async () => {
    await api.marketplace
      .getMarketplaceProductById(product.marketplace_product_id)
      .then((res) => {
        console.log("res", res);
        if (res.isStatus) {
          setDetail(res.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  };

  if (!product || !detail) {
    return null;
  }
  if (detail) {
    const { Product, updated_date } = detail;

    return (
      <Dialog
        open={open}
        onClose={closeModal}
        fullWidth
        maxWidth="md"
        key={product.marketplace_product_id}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "25px",
          },
        }}
      >
        <DialogContent
          sx={{
            padding: 2,
            mb: 1,
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: "relative",
                  height: "556px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Slider
                  {...settingsMain}
                  ref={(slider) => (silderRef = slider)}
                >
                  {Product.Pictures.map((image, index) => (
                    <Box
                      key={index}
                      component={"img"}
                      src={image.pic}
                      alt={Product.product_name + "-" + index}
                      sx={{
                        width: "100%",
                        height: "446px",
                        borderRadius: "25px",
                      }}
                    />
                  ))}
                </Slider>
                <Grid container spacing={2}>
                  {Product.Pictures.slice(0, 3).map((image, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      {index === 2 && Product.Pictures.length > 3 ? (
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: "100px",
                            borderRadius: "25px",
                            overflow: "hidden",
                            cursor: "pointer",
                          }}
                          onClick={() => silderRef.slickGoTo(index)}
                        >
                          <Box
                            component={"img"}
                            src={image.pic}
                            alt={Product.product_name + "-" + index}
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0, 0, 0, 0.5)", // คลุมทึบ
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "white",
                                fontSize: "24px",
                                fontWeight: "bold",
                              }}
                            >
                              +{Product.Pictures.length - 3}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          component={"img"}
                          src={image.pic}
                          alt={Product.product_name + "-" + index}
                          sx={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "25px",
                            cursor: "pointer",
                          }}
                          onClick={() => silderRef.slickGoTo(index)}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
                  <Typography
                    sx={{
                      fontSize: "32px",
                      fontWeight: "medium",
                      color: "#212529",
                    }}
                    noWrap
                  >
                    {Product.product_name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "32px",
                      fontWeight: "medium",
                    }}
                  >
                    {Product.price >= 1000000
                      ? `${(Product.price / 1000000).toFixed(
                          Product.price % 1000000 > 0 ? 1 : 0
                        )} ล้านบาท`
                      : `${Product.price.toLocaleString()} บาท`}
                  </Typography>

                  <Table
                    sx={{
                      "& .MuiTableCell-root": {
                        borderBottom: "none",
                        padding: 1,
                        fontSize: "16px",
                        verticalAlign: "top",
                      },
                      "& .MuiTableCell-head": {
                        whiteSpace: "nowrap",
                      },
                      "& .MuiTableCell-body:first-of-type": {
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableBody>
                      <TableRow>
                        <TableCell>อัปเดต</TableCell>
                        <TableCell>{updated_date}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>รหัสสินค้า</TableCell>
                        <TableCell>{Product?.product_code}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>หมวดหมู่สินค้า</TableCell>
                        <TableCell>{Product?.Category?.name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>ตำหนิ</TableCell>
                        <TableCell>{Product?.blemishes}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>จำนวนคงเหลือ</TableCell>
                        <TableCell>{Product?.remaining_amount}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>ช่องทางการติดต่อ</TableCell>
                        <TableCell>
                          <Typography>
                            {Product?.Company?.marketplace_address}
                          </Typography>
                          <Typography>{Product?.Company?.phone}</Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "12px",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "medium",
                        color: "#D32F2F",
                      }}
                    >
                      ระวังมิจฉาชีพหลอกโอนเงิน หรือโอนเงินผิดบัญชี!
                    </Typography>
                    <Button
                      sx={{
                        color: "#00bb9f",
                        border: "1px solid #00bb9f",
                        borderRadius: "12px",
                        fontSize: "16px",
                        "&:hover": {
                          background: "white",
                          color: "#00bb9f",
                        },
                      }}
                      onClick={closeModal}
                    >
                      ปิด
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
};

export default ModalProduct;
